import React from 'react';
import {MacroFooter} from './MacroFooter';
import {macroFooterRef} from '../../constants';

export async function renderMacroFooter(root) {
    root.render(<MacroFooter ref={macroFooterRef} />);

    return macroFooterRef;
}
